<kodit-dropdown
  [options]="items"
  ctrlTooltip="Izaberite magacin"
  ctrlTooltipPosition="top"
  [formCtrl]="magacinCtrl"
  [canFilter]="true"
></kodit-dropdown>
